export default __webpack_public_path__ + "static/0306-535fd8a7ade37ba3f1f3aad469921373.png";